import React from 'react';
import DocumentMeta from 'react-document-meta';
import BlogSection from '../components/BlogSection';
import styles from '../styles/Blog.module.css';

const publicUrl = process.env.PUBLIC_URL || '';

const posts = [
  {
    id: 'sourdough-time',
    category: 'Artisan bread',
    title: 'Why sourdough needs time',
    image: `${publicUrl}/images/breads/dinkel-pure.jpg`,
    imageAlt: 'Homemade spelt sourdough bread',
    readLabel: 'Read more',
    to: `${publicUrl}/Blog/sourdough`,
    toByLanguage: {
      de: `${publicUrl}/Blog/sauerteig`,
      bg: `${publicUrl}/Blog/kvas`,
    },
  },
  {
    id: 'tea-moments',
    category: 'Tea & moments',
    title: 'A slower cup of tea',
    image: `${publicUrl}/images/tea/tea-cup.webp`,
    imageAlt: 'A warm cup of tea',
    readLabel: 'Read more',
    to: `${publicUrl}/Tea`,
  },
  {
    id: 'sweet-finish',
    category: 'Good food',
    title: 'A sweet finish to the table',
    image: `${publicUrl}/images/desserts/Pastry.webp`,
    imageAlt: 'Fresh Grain Bites pastry',
    readLabel: 'Read more',
    to: `${publicUrl}/Desserts`,
  },
  {
    id: 'bread-sharing',
    category: 'At the table',
    title: 'Bread made for sharing',
    image: `${publicUrl}/images/breads/dinkel-fruits2.jpg`,
    imageAlt: 'Sliced homemade spelt bread',
    readLabel: 'Read more',
    to: `${publicUrl}/Artisan-Breads`,
  },
  {
    id: 'tea-character',
    category: 'Tea & character',
    title: 'From herbs to a beautiful cup',
    image: `${publicUrl}/images/tea/mursalski-tea.webp`,
    imageAlt: 'Loose leaf herbal tea',
    readLabel: 'Read more',
    to: `${publicUrl}/Tea`,
  },
  {
    id: 'kozunak-season',
    category: 'Sweet baking',
    title: 'The soft, sweet kozunak',
    image: `${publicUrl}/images/breads/kozunak5.jpg`,
    imageAlt: 'Homemade kozunak',
    readLabel: 'Read more',
    to: `${publicUrl}/Menu`,
  },
];

const Blog = () => {
  const meta = {
    title: 'Journal | Grain Bites',
    description: 'Stories about homemade bread, tea, food, and the Grain Bites table.',
    meta: {
      name: {
        keywords: 'Grain Bites journal, artisan bread, sourdough, tea, food',
        robots: 'index, follow',
        author: 'Irena Popova',
        'twitter:card': 'summary_large_image',
        'twitter:title': 'Journal | Grain Bites',
        'twitter:description': 'Stories about homemade bread, tea, food, and the Grain Bites table.',
      },
      property: {
        'og:type': 'website',
        'og:title': 'Journal | Grain Bites',
        'og:description': 'Stories about homemade bread, tea, food, and the Grain Bites table.',
        'og:image': `${publicUrl}/images/breads/dinkel-pure.jpg`,
      },
    },
  };

  return (
    <DocumentMeta {...meta} extend>
      <main className={styles.page}>
        <header className={styles.hero}>
          <p className={styles.label}>Grain Bites</p>
          <h1>Journal</h1>
          <p>Notes on bread, tea, good food, and the moments around the table.</p>
        </header>

        <BlogSection
          eyebrow="Journal"
          title="Stories from Grain Bites"
          posts={posts}
          moreLabel="Read the sourdough guide"
          moreTo={`${publicUrl}/Sourdough`}
        />
      </main>
    </DocumentMeta>
  );
};

export default Blog;
